import { render, staticRenderFns } from "./buyManage.vue?vue&type=template&id=6f72f6de"
import script from "./buyManage.vue?vue&type=script&lang=js"
export * from "./buyManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports